<template>
  <section class="empty-stock-container">
    <div class="empty-stock-card">
      <div class="illustration-wrapper">
        <div class="illustration-bg">
          <img
            src="@/assets/img/eso-empty.svg"
            alt="Employee stock options"
            class="illustration"
          />
        </div>
      </div>
      <div class="content-wrapper">
        <h2 class="empty-title">
          Set Up Employee Stock Options
        </h2>
        <p class="empty-description">
          Reward your employees and give them a chance to be a real part of the
          dream. Create an equity incentive program to attract and retain top talent.
        </p>
        <form @submit.prevent="$emit('show-modal')" class="action-form">
          <CustomButton
            class="setup-btn"
            title="Set up Employee Benefit"
            v-can.disable="'deal:addDeal'"
          />
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import CustomButton from "@/components/general/BtnComponent";
export default {
  name: "StockEmptyState",

  emits: ["show-modal"],

  components: {
    CustomButton,
  },
};
</script>

<style lang="scss" scoped>
.empty-stock-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 240px);
  padding: 24px;
}

.empty-stock-card {
  background: white;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
  padding: 48px 40px;
  max-width: 480px;
  width: 100%;
  text-align: center;
}

.illustration-wrapper {
  margin-bottom: 32px;
}

.illustration-bg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 180px;
  background: linear-gradient(135deg, #F0F5FF 0%, #E8F0FE 100%);
  border-radius: 50%;
}

.illustration {
  width: 120px;
  height: auto;
}

.empty-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 20px;
  font-weight: 500;
  color: #0F172A;
  margin: 0 0 12px 0;
}

.empty-description {
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  line-height: 1.6;
  color: #64748B;
  margin: 0 0 28px 0;
}

.action-form {
  display: flex;
  justify-content: center;
}

.setup-btn {
  min-width: 220px;
}
</style>
